/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectOrdersPlanningsContainerDomain = state => state.ordersPlanningsContainerReducer || initialState;

export const getIsOrdersPlanningsListLoadingSelector = () =>
	createSelector(
		selectOrdersPlanningsContainerDomain,
		({ isOrdersPlanningsListLoading }) => isOrdersPlanningsListLoading,
	);

export const getOrdersPlanningsListSelector = () =>
	createSelector(selectOrdersPlanningsContainerDomain, ({ ordersPlanningsList }) => {
		if (!ordersPlanningsList || ordersPlanningsList.length === 0) {
			return [];
		}

		return ordersPlanningsList.map(ordersPlanning => ({
			...ordersPlanning,
		}));
	});

export const getPaginationSelector = () =>
	createSelector(selectOrdersPlanningsContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getGroupsSelector = () => createSelector(selectOrdersPlanningsContainerDomain, ({ groups }) => groups);

export const getIsGroupsLoadingSelector = () =>
	createSelector(selectOrdersPlanningsContainerDomain, ({ isGroupsLoading }) => isGroupsLoading);

export const getConfigsSelector = () => createSelector(selectOrdersPlanningsContainerDomain, ({ configs }) => configs);

export const getIsConfigsLoadingSelector = () =>
	createSelector(selectOrdersPlanningsContainerDomain, ({ isConfigsLoading }) => isConfigsLoading);
